import { styled } from '@mui/system';
import { Typography, Box } from '@mui/material';
import { customPalette } from '../../../styles/palette';

export const TypographyStyledHeader = styled(Typography)(() => ({
  fontFamily: 'BGRegular',
  fontWeight: 'bolder',
  color: customPalette.primaryDark,
  fontSize: '1.625rem',
  lineHeight: '1.875rem',
  textAlign: 'center',
  width: '50%',
  paddingBottom: '1.875rem',
  '@media(max-width:767px)': {
    fontSize: '1.65rem'
  }
}));

export const BoxStyled = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  paddingBlock: '1.875rem'
});
